import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiConfig';

/**
 * 登录函数
 * @param {string} username 用户名或邮箱
 * @param {string} password 密码
 * @returns {Promise<{ token: string }>} 返回包含 token 的对象
 */
export const login = async (username: string, password: string): Promise<{ token: string }> => {
  try {
    const apiBaseUrl = getApiBaseUrl();
    // console.log('登录请求 URL:', `${apiBaseUrl}/login`);
    // console.log('登录用户名:', username);

    // 调用后端登录接口
    const response = await axios.post(`${apiBaseUrl}/login`, {
      username,
      password,
    });

    // 检查响应是否包含 token
    if (response.data && response.data.token) {
      // console.log('登录成功，Token:', response.data.token);
      return { token: response.data.token };
    } else {
      throw new Error('登录失败：未返回有效的 Token');
    }
  } catch (err: any) {
    console.error('登录失败:', err);

    // 处理 HTTP 错误响应
    if (err.response) {
      const errorData = err.response.data;
      if (errorData?.error) {
        // 根据后端返回的错误信息，提供更友好的提示
        if (errorData.error === 'No User') {
          throw new Error('用户不存在，请检查用户名或邮箱');
        } else if (errorData.error === 'Incorrect password') {
          throw new Error('密码错误，请重试');
        } else {
          throw new Error(errorData.error);
        }
      }
    }

    // 处理网络错误或其他错误
    if (err.message) {
      throw new Error(err.message);
    }

    throw new Error('登录失败，请检查网络连接或稍后重试');
  }
};

